import React from 'react';
import { Box, Card, Chip, Stack, Typography } from '@mui/material';
import Config from '../config/config';
import './CardProducts.css';

const SEM_IMAGEM = 'https://katuxa.sfo3.digitaloceanspaces.com/pdv/sem-imagem.jpg';
const FOTO_TRATAMENTO = 'https://katuxa.sfo3.digitaloceanspaces.com/pdv/foto_tratamento.jpg';

const ProductImage = ({ product }) => {
    const temImagens = product.images && product.images.length > 0;

    if (!temImagens) {
        const src = product.base64
            ? `data:image/jpeg;base64,${product.base64}`
            : SEM_IMAGEM;
        return (
            <Box
                component="img"
                src={src}
                alt={product.use_descricao}
                sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
        );
    }

    const thumbUrl = (pos) => `${Config.base_fotos}/fotos/${product.produto}_${product.cor_produto}_${pos}.jpg`;
    const posicaoInicial = product.images.length > 1 ? '02' : '01';

    const handleError = ({ currentTarget }) => {
        if (posicaoInicial === '02' && currentTarget.dataset.fallback !== '01') {
            currentTarget.dataset.fallback = '01';
            currentTarget.src = thumbUrl('01');
            return;
        }
        currentTarget.onerror = null;
        currentTarget.src = FOTO_TRATAMENTO;
    };

    return (
        <Box
            component="img"
            className="card-img-top"
            src={thumbUrl(posicaoInicial)}
            alt={product.use_descricao}
            onError={handleError}
            sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
    );
};

const CardProduct = ({ product, verProdutoProps }) => {
    const temEstoque = product.grades && product.grades.length > 0;

    return (
        <Card
            elevation={0}
            onClick={verProdutoProps}
            sx={{
                cursor: 'pointer',
                borderRadius: 1.5,
                border: '1px solid',
                borderColor: 'grey.200',
                overflow: 'hidden',
                transition: 'all 0.15s ease',
                '&:hover': {
                    borderColor: 'primary.light',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                },
            }}
        >
            {/* Imagem */}
            <Box
                sx={{
                    position: 'relative',
                    height: 150,
                    bgcolor: 'grey.50',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    p: 0.5,
                }}
            >
                <ProductImage product={product} />
                {!temEstoque && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 4,
                            left: 4,
                            px: 0.75,
                            py: 0.15,
                            borderRadius: 0.5,
                            bgcolor: 'error.main',
                            color: '#fff',
                            fontSize: 9,
                            fontWeight: 700,
                            letterSpacing: 0.5,
                        }}
                    >
                        SEM ESTOQUE
                    </Box>
                )}
            </Box>

            {/* Conteúdo */}
            <Stack spacing={0.75} sx={{ p: 1 }}>
                <Typography
                    sx={{
                        fontSize: 11.5,
                        fontWeight: 600,
                        color: 'text.primary',
                        lineHeight: 1.25,
                        minHeight: 28,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                    }}
                >
                    {product.use_descricao}
                </Typography>

                {product.use_cor_produto && (
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={0.5}
                        sx={{
                            pt: 0.75,
                            borderTop: '1px dashed',
                            borderColor: 'grey.200',
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: 9,
                                fontWeight: 600,
                                color: 'text.secondary',
                                textTransform: 'uppercase',
                                letterSpacing: 0.4,
                            }}
                        >
                            Cor
                        </Typography>
                        <Typography sx={{ fontSize: 10.5, fontWeight: 600, color: 'text.primary' }}>
                            {product.use_cor_produto}
                        </Typography>
                    </Stack>
                )}

                {temEstoque ? (
                    <Stack direction="row" spacing={0.4} flexWrap="wrap" useFlexGap>
                        {product.grades.map((grade, index) => (
                            <Chip
                                key={index}
                                label={grade}
                                size="small"
                                sx={{
                                    height: 17,
                                    fontSize: 10,
                                    fontWeight: 600,
                                    bgcolor: 'grey.100',
                                    color: 'text.primary',
                                    border: '1px solid',
                                    borderColor: 'grey.300',
                                    '& .MuiChip-label': { px: 0.6 },
                                }}
                            />
                        ))}
                    </Stack>
                ) : (
                    <Typography sx={{ fontSize: 10, fontWeight: 600, color: 'error.dark' }}>
                        Indisponível no momento
                    </Typography>
                )}
            </Stack>
        </Card>
    );
};

export default CardProduct;
